/**
 * Daton ``environment.*.ts`` ``CDK_ENABLED_SOURCES``: types that open ``/u/add-source-new``.
 * Types not in this set (but still CDK catalog rows) use ``/u/add-studio-source``.
 * Override at deploy time via ``VITE_DATON_CDK_ENABLED_SOURCES`` (comma-separated).
 */

/** Default dev list — keep in sync with webapp ``environment.development.ts``. */
export const DEFAULT_DATON_CDK_ENABLED_SOURCES: readonly string[] = [
  "GITLABV2",
  "AIRCALL1",
  "SHIPSTATION",
  "KLAVIYOV2",
  "AIRCALL",
  "BIGCOMMERCE_CDK",
  "BOLRETAIL_CDK",
  "CALENDLY_V2",
  "CLICKUPV2",
  "MAILCHIMP1",
  "WALMART_CDK",
  "SUGARCRM",
  "BYRD",
  "SHOPIFY_V2",
  "AFTERSHIP_V2",
  "EASYPOST",
  "SKUBANA",
  "COMMISSIONJUNCTION",
  "INVENTORYPLANNER",
  "WOOCOMMERCE_CDK",
  "RECHARGEPAYMENTS_CDK",
  "TABOOLA",
  "SHIPHERO",
  "SHIPBOB",
];

/** Normalize catalog type keys for comparison with Daton's list. */
export function normalizeDatonSourceType(type: string): string {
  return type.trim().toUpperCase().replace(/-/g, "_");
}
